<template>
    <div>
        <CommonPopupFrame :zIndex="100" :isOpen="isOpen" :closeCompleteAction="closeCompleteAction" :changeBottom="0">
            <div style="margin-top: 16px; padding: 0 20px; padding-bottom: 10px; display: flex; justify-content: space-between; align-items: center; position: relative;">
                <div style="font-weight: 700; padding-bottom: 16px; color: #808080;" @click="closeCompleteAction">
                    닫기
                </div>
                <div @click="confirmEnterJoin" style="font-weight: 700; padding-bottom: 16px; color: var(--color-main);">입장하기</div>
            </div>
            <div style="margin-top: 16px; text-align: center; padding: 0 20px;">
                <div style="font-size: 32px;font-weight: 700;line-height: 46px;">입장 코드 입력</div>
                <div style="margin-top: 40px;">
                    <div style="font-weight: 500;line-height: 23px; margin-bottom: 4px;">입장 코드 힌트</div>
                    <div style="font-size: 20px;font-weight: 700;line-height: 28px;">{{ passwordHint === null ? '입장코드가 아직 등록되지 않았습니다.' : passwordHint }}</div>
                </div>
                <input v-model="password" style="margin-top: 24px; width: 100%; padding: 12px; border-radius: 12px; border: none; outline: none; background-color: #f5f5f5;" placeholder="입장 코드" type="tel">
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'

export default {
    name: 'MemberTalkPasswordInputModal',
    components: {
        CommonPopupFrame
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeCompleteAction: {
            type: Function,
            default: () => { }
        },
        scheduleIdx: {
            type: [Number, String],
            default: ''
        },
        enterJoin: {
            type: Function,
            default: () => { }
        },
        passwordHint: {
            type: String,
            default: ''
        }
    },
    created() {

    },
    data() {
        return {
            password: null
        }
    },
    methods: {
        confirmEnterJoin() {
            if (this.password === null || this.password === '') {
                this.$GlobalStore.showAlert('입장 코드를 입력해주세요.')
                return
            }
            this.enterJoin(this.password)
            this.password = null
        }
    },
    watch: {

    }
}
</script>

<style scoped>
* {
    color: #210f03;
}

.common_btn {
    border-radius: 12px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background-color: #f5f5f5;
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 12px;
    color: var(--color-main);
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 33px;
}

.image_wrap {
    text-align: center;
}

.image_wrap img {
    width: 40px;
    height: 40px;
}
</style>